
<div class="cbu-main-container">
    <i class="fa-solid fa-circle-user"></i>
    <div class="cbu-container">
    <div class="cbu-text-container">
        {{message}}
    </div>
    </div>
   
</div>
